export default __webpack_public_path__ + "img/5442b589dce60b588e4ae8f807619d8a.png";